export const setLocale = (locale = 'en') => (
	(dispatch, getState) => {
		if (getState().locale !== locale) {
			dispatch({
				type: 'UPATE_STORE_LOCALE',
				payload: locale
			})
		}
	}
)